(function() {
  if (window.gromCategoryGridMenuLinks) return;
  window.gromCategoryGridMenuLinks = true;

  function normalize(text) {
    return (text || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function isVisible(el) {
    return !!el && el.getClientRects().length > 0;
  }

  function findDesktopLink(title) {
    var links = document.querySelectorAll('.site-nav > .site-nav__item > .site-nav__link');
    for (var i = 0; i < links.length; i++) {
      if (normalize(links[i].textContent) === title && isVisible(links[i])) return links[i];
    }
    return null;
  }

  function findDrawerTrigger(title) {
    var items = document.querySelectorAll('#NavDrawer .mobile-nav > .mobile-nav__item');
    for (var i = 0; i < items.length; i++) {
      var label = items[i].querySelector('.mobile-nav__has-sublist .mobile-nav__faux-link, .mobile-nav__has-sublist > .mobile-nav__link');
      if (label && normalize(label.textContent) === title) {
        return items[i].querySelector('.mobile-nav__has-sublist .collapsible-trigger');
      }
    }
    return null;
  }

  function openDesktop(navLink) {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    navLink.focus({ preventScroll: true });
  }

  function openDrawer(trigger, source) {
    theme.NavDrawer.open(null, source);
    if (!trigger.classList.contains('is-open')) trigger.click();
  }

  window.addEventListener('click', function(evt) {
    var link = evt.target.closest && evt.target.closest('a[data-open-menu]');
    if (!link) return;
    if (evt.button !== 0 || evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey) return;

    var title = normalize(link.dataset.openMenu);
    var navLink = findDesktopLink(title);
    var trigger = navLink ? null : findDrawerTrigger(title);
    if (!navLink && !(trigger && window.theme && theme.NavDrawer)) return;

    evt.preventDefault();
    evt.stopImmediatePropagation();

    if (navLink) {
      openDesktop(navLink);
    } else {
      openDrawer(trigger, link);
    }
  }, true);
})();
